'use client';

import { useState, useContext, createContext, useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import { Category, GameType } from '@/types/category-setting';

interface SingleMatchFilterContextProps {
	sportType: number;
    setSportType: (value: number) => void;
    gameType: GameType;
    setGameType: (value: GameType) => void;
    category: Category,
    setCategory: (value: Category) => void;
	currMap: number;
    setCurrMap: (value: number) => void;
	isMute: boolean;
	setIsMute:(value: boolean) => void;
	isAllBetTypeCollapse: boolean;
	setIsAllBetTypeCollapse:(value: boolean) => void;
	isFirstDeeplinkCS: boolean;
	setIsFirstDeeplinkCS:(value: boolean) => void;
};

const SingleMatchFilterContext = createContext<SingleMatchFilterContextProps>({
	sportType: 0,
	setSportType: () => {},
	gameType: 'none',
	setGameType: () => {},
	category: 'Main',
	setCategory: () => {},
	currMap: 0,
	setCurrMap: () => {},
	isMute: false,
	setIsMute: () => {},
	isAllBetTypeCollapse: false,
	setIsAllBetTypeCollapse: () => {},
	isFirstDeeplinkCS: false,
	setIsFirstDeeplinkCS: () => {}
});

export function SingleMatchFilterProvider({
	sport,
	children
}: { 
    sport: number,
    children: React.ReactNode
 }) {
	const searchParams = useSearchParams();
	const categoryFromUrl = searchParams.get('cate') as Category;
	const [sportType, setSportType] = useState<number>(sport);
	const [gameType, setGameType] = useState<GameType>('none');
	const [category, setCategory] = useState<Category>(categoryFromUrl ?? 'Main');
	const [currMap, setCurrMap] = useState<number>(0);
	const [isMute, setIsMute] = useState<boolean>(false);
	const [isAllBetTypeCollapse, setIsAllBetTypeCollapse] = useState<boolean>(false);
	const [isFirstDeeplinkCS, setIsFirstDeeplinkCS] = useState<boolean>(true);

	const value = useMemo(() => ({ 
		sportType, 
		setSportType, 
		gameType, 
		setGameType,
		category,
		setCategory,
		currMap,
		setCurrMap,
		isMute, 
		setIsMute,
		isAllBetTypeCollapse,
		setIsAllBetTypeCollapse,
		isFirstDeeplinkCS,
		setIsFirstDeeplinkCS
	}), [sportType, gameType, category, isMute, isAllBetTypeCollapse]);

	return (
		<SingleMatchFilterContext.Provider value={value}>
			{children}
		</SingleMatchFilterContext.Provider>
	);
}

export const useSingleMatchFilter = () => useContext(SingleMatchFilterContext);
